module.exports = __webpack_public_path__ + "img/card_3.8006f05e.jpg";